import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";

export interface IConsultnat {
    consultant_ID?: number,
    consultant_Name?: string,
    consultant_Email_ID?: string,
    city_Name?: string,
    consultant_State?: string,
    consultant_Job_Title?: string,
    consultant_Home_No?: string,
    consultant_Cell_No?: string,
    visa_Name?: string,
    consultant_Status?: string,
    tax_Term?: string,
}

interface Iprops {
    po: IPurchaseOrder,
    toast: any
}
export const ConsultantInformation = (props: Iprops) => {
    const [consultantInfo, setConsultantInfo] = useState<IConsultnat>();
    const loadConsultantData = async () => {
        const response = await Fetch("Consultant_Mast/byId", "GET", null, `consultant_id=${props.po.consultant_ID}`, props.toast);
        if (response) {
            const data: IConsultnat = await response.json();
            setConsultantInfo(data);
        }
    }
    useEffect(() => { if (props.po.consultant_ID) loadConsultantData(); }, [props.po.consultant_ID]);

    return (
        <div className='w-11 m-auto mt-2'>
            <div className="grid formgrid">
                <h5 className="field col-12 md:col-4 mt-4">Cons ID : <span className='text-600 font-light'>{consultantInfo?.consultant_ID}</span></h5>
                <h5 className="field col-12 md:col-4">Name : <span className='text-600 font-light'></span>{consultantInfo?.consultant_Name}</h5>
                <h5 className="field col-12 md:col-4">Email id : <span className='text-600 font-light'>{consultantInfo?.consultant_Email_ID}</span></h5>

                <h5 className="field col-12 md:col-4">Job Title : <span className='text-600 font-light'>{consultantInfo?.consultant_Job_Title}</span></h5>
                <h5 className="field col-12 md:col-4">Phone : <span className='text-600 font-light'>{consultantInfo?.consultant_Home_No}</span></h5>
                <h5 className="field col-12 md:col-4">Cell No : <span className='text-600 font-light'>{consultantInfo?.consultant_Cell_No}</span></h5>

                <h5 className="field col-12 md:col-4">Location : <span className='text-600 font-light'>{consultantInfo?.city_Name}, {consultantInfo?.consultant_State}</span></h5>
                <h5 className="field col-12 md:col-4">Visa : <span className='text-600 font-light'>{consultantInfo?.visa_Name}</span></h5>
                <h5 className="field col-12 md:col-4">Status : <span className='text-600 font-light'>{consultantInfo?.consultant_Status}</span></h5>
            </div>
        </div>
    );
}